(function() {
	angular.module('meanApp').controller('recipesAdminCtrl', recipesAdminCtrl);

	recipesAdminCtrl.$inject = [ '$scope', '$location', 'recipesManager', '$rootScope', 'alert', 'confirmationModal' ];
	function recipesAdminCtrl($scope, $location, recipesManager, $rootScope, alert, confirmationModal) {
		var vm = this;
		//console.log('the current user is ', $rootScope.currentUser);
		vm.recipes = {};
		vm.filters = {};
		vm.totalPages = 0;
		vm.totalNbRecipes = 0;
		vm.currentPage = 1;

		$rootScope.$watch(
			'currentUser',
			function() {
				if ($rootScope.currentUser) {
					if ($rootScope.currentUser.role === 'admin') {
						loadRecipes();
					} else {
						$location.path('/');
					}
				}
			},
			function(err) {
				console.log(err);
			}
		);

		var loadRecipes = function() {
			recipesManager.getAllRecipesAdmin(vm.currentPage, vm.filters).then(
				function(result) {
					vm.recipes = result.collection;
					vm.totalPages = result.pages;
					vm.totalNbRecipes = result.total;
				},
				function(err) {
					console.log('erreur loading all profiles');
					console.log(err);
				}
			);
		};

		vm.pageChanged = function() {
			loadRecipes();
		};

		vm.filterOnDrafts = function() {
			vm.filters.isDraft = true;
			loadRecipes();
		};

		vm.executeCleverAlgo = function() {
			recipesManager.executeCleverAlgo();
		};

		vm.filterOnUnknownIngredients = function() {
			vm.filters.unknownIngredientsQuantity = true;
			loadRecipes();
		};

		vm.confirmationQuestion = 'Voulez vous vraiment supprimer cette recette ? Cette opération sera irréversible';
		vm.onConfirmationModalClick = function() {
			recipesManager.delete($scope.recipeIDToDelete).then(
				function() {
					this.$close();
					alert.push('success', 'Cette mesure a été supprimée définitivement de la base de données');
				}.bind($scope),
				function() {
					this.$close();
					alert.push('danger', "Cette mesure n'a pas pu être supprimée");
				}.bind($scope)
			);
		};

		//just remove a recipe while calling API
		vm.removeRecipe = function(recipeId) {
			$scope.recipeIDToDelete = recipeId;
			$scope.modalInstance = confirmationModal.open($scope, 'recipesAdminCtrl');
		};

		/*vm.onEmailSubmit = function() {
          if (vm.email) {
              var newAuthorUser = recipesManager.set({
                  email: vm.email,
                  role: 'author'
              });
              newAuthorUser.save()
              .then(function (user) {
                  alert.push('success', 'Nouvel utililisateur ajouté en base de données');
              }, function (error) {
                  //TOOD préciser si déja en base de données ou quoi
                  alert.push('danger', 'Utilisateur non ajouté en base de données, car erreur');
              });
          }
      };*/

		vm.availableOptions = [
			{ id: 'member', name: 'Membre' },
			{ id: 'author', name: 'Auteur' },
			{ id: 'admin', name: 'Administrateur', disabled: true }
		];

		vm.onChangeRole = function() {
			//conditions :
			//1- user that is admin cant have another role
			//2- no user can become admin through this interface

			//at least option has changed
			if (vm.selectedOption.id !== vm.searchUser.role) {
				vm.searchUser
					.update({
						role: vm.selectedOption.id
					})
					.then(
						function(user) {
							alert.push('success', 'Le role a bien ete changé');
						},
						function(error) {
							//TOOD préciser si déja en base de données ou quoi
							alert.push('danger', 'role non changé, une erreur est survenue');
						}
					);
			}
		};

		/*vm.onSearchUserSubmit = function() {
          if (vm.emailSearch) {
              usersManager.searchUserByEmail(vm.emailSearch)
              .then(function(user) {
                  vm.searchUser = user;
                  vm.selectedOption = { id : vm.searchUser.role};
              }, function(err) {
                  console.log('erreur searching the profile');
                  console.log(err);
              });
          }
      };*/
	}
})();
